import { useEffect, useState } from 'react';

declare global {
  interface ModernizrStatic {
    stringreplaceall: boolean;
  }
}

export const useFeatureTest = () => {
  const [isSupported, setIsSupported] = useState(true);
  useEffect(() => {
    const testModernizr = async () => {
      const Modernizr = await import('modernizr');
      Modernizr.addTest(
        'stringReplaceAll',
        () => !!String.prototype.replaceAll,
      );
      // Before adding a feature to test, verify that it does not use `eval` under the hood.
      const features = [
        Modernizr.es6array,
        Modernizr.es6collections,
        Modernizr.es6math,
        Modernizr.es6number,
        Modernizr.es6object,
        Modernizr.es6string,
        Modernizr.promises,
        Modernizr.stringreplaceall,
      ];
      // using a for loop to ensure this doesnt error out on very old browsers
      for (let i = 0; i++; i < features.length) {
        if (!features[i]) {
          return false;
        }
      }
      return true;
    };

    testModernizr().then(supported => setIsSupported(supported));
  }, []);

  return isSupported;
};
